export default __webpack_public_path__ + "static/chat-002ca2eba38bb0148e34afced8c5369d.png";